import React, {useCallback, useEffect} from 'react';

declare global {
    interface Window {
        turnstile: any;
        turnstileCallback: (token: string) => void;
        onloadTurnstileCallback: () => void;
    }
}

function TurnstileCaptchaRenderer({onChange}) {
    const render = useCallback(()=>{
        if(window.turnstile) {
            window.turnstile.render('#cf-turnstile', {
                sitekey: '0x4AAAAAAALRXKa8yBsKwSxF',
                theme: "light",
                callback: function(token) {
                    onChange({
                        target:{
                            value:{
                                type:'turnstile',
                                value: token,

                            }
                        }
                    })
                },
            });
            window.turnstileCallback = function (token) {
                onChange({
                    target:{
                        value:{
                            type:'turnstile',
                            value: token,
                        }
                    },
                });
            }
        }
    },[onChange])

    useEffect(() => {
        const d = document.createElement('script');
        d.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=onloadTurnstileCallback";
        d.onload = render;
        document.body.appendChild(d);

        return ()=>{
            document.body.removeChild(d);
        }
    }, []);
    return (
        <>
            <div id="cf-turnstile"
                 data-theme={"light"}
                 data-sitekey="0x4AAAAAAALRXKa8yBsKwSxF"
                 data-callback="turnstileCallback"></div>
        </>
    );
}

export default TurnstileCaptchaRenderer;
